import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
export default function XaritadagiManzilimiz() {
  return <section data-section-id="223598" id="the-studio" className="bg-background text-foreground relative w-full h-[600px] md:h-[700px] overflow-hidden">
      {}
      <div className="absolute inset-0 w-full h-full bg-muted">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.019234762081!2d-122.4194155!3d37.7749295!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085809c6c8f4459%3A0xb10ed6d9b5050c62!2sSan%20Francisco%2C%20CA!5e0!3m2!1sen!2s!4v1680000000000!5m2!1sen!2s" className="w-full h-full border-0 filter grayscale invert contrast-150 opacity-90" allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Pivotal Placement Studio Location"></iframe>
        {}
        <div className="absolute inset-0 bg-background/40 pointer-events-none"></div>
      </div>

      {}
      <div className="absolute top-8 left-4 right-4 md:top-1/2 md:-translate-y-1/2 md:left-12 md:right-auto md:w-[420px] z-10">
        <Card className="bg-card/80 backdrop-blur-2xl border-border rounded-none shadow-none">
          <CardHeader className="pb-4">
            <CardTitle className="font-default text-3xl font-bold tracking-tighter uppercase">
              The Studio
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="bg-primary/10 p-2 rounded-none shrink-0 mt-0.5">
                <MapPin className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h4 className="font-mono font-semibold text-foreground text-xs uppercase tracking-widest mb-1">
                  Location
                </h4>
                <p className="font-mono text-muted-foreground text-sm leading-relaxed">
                  742 Cinematic Way, Suite 101<br />San Francisco, CA 94103
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="bg-primary/10 p-2 rounded-none shrink-0 mt-0.5">
                <Clock className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h4 className="font-mono font-semibold text-foreground text-xs uppercase tracking-widest mb-1">
                  Production Hours
                </h4>
                <p className="font-mono text-muted-foreground text-sm leading-relaxed">
                  Mon - Fri: 08:00 - 20:00
                  <br />
                  Sat: By Appointment Only
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="bg-primary/10 p-2 rounded-none shrink-0 mt-0.5">
                <Phone className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h4 className="font-mono font-semibold text-foreground text-xs uppercase tracking-widest mb-1">
                  Direct Line
                </h4>
                <p className="font-mono text-muted-foreground text-sm leading-relaxed">
                  +1 (415) 555-0198
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="bg-primary/10 p-2 rounded-none shrink-0 mt-0.5">
                <Mail className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h4 className="font-mono font-semibold text-foreground text-xs uppercase tracking-widest mb-1">
                  Inquiries
                </h4>
                <p className="font-mono text-muted-foreground text-sm leading-relaxed">
                  hello@pivotalplacement.com
                </p>
              </div>
            </div>

            <div className="pt-2">
              <Button className="w-full bg-primary text-primary-foreground rounded-none font-mono uppercase tracking-widest hover:opacity-90 transition-opacity" size="lg">
                Get Directions
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}